export default __webpack_public_path__ + "static/media/Return_BTN.a4914789.svg";